'use client';

import { variantToIconMap } from "../constants.js";
import { variantToLabelMap } from "../NotificationInline.data.js";
import { defaultProps } from "../NotificationInline.defaultProps.js";
const emptyActions = [];
function processProps({
  onDismiss: _,
  ...props
}) {
  const variant = props.variant ?? defaultProps.variant;
  const actions = (props.actions ?? emptyActions).slice(0, 2);
  let a11yImportance = props.a11yImportance || defaultProps.a11yImportance;
  if (variant === "upsell") {
    a11yImportance = "none";
  }
  return {
    ...props,
    label: props.a11yLabel || variantToLabelMap[variant],
    // `??` not used as empty strings need to be handled here
    Icon: variantToIconMap[variant],
    variant,
    dismissable: props.dismissable ?? false,
    actions,
    a11yImportance
  };
}
export {
  processProps
};
